/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Read_The_DocsInputs */

const en_marketing_read_the_docs = /** @type {(inputs: Marketing_Read_The_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the docs`)
};

const es_marketing_read_the_docs = /** @type {(inputs: Marketing_Read_The_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer la documentación`)
};

const fr_marketing_read_the_docs = /** @type {(inputs: Marketing_Read_The_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lire la documentation`)
};

/**
* | output |
* | --- |
* | "Read the docs" |
*
* @param {Marketing_Read_The_DocsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_read_the_docs = /** @type {((inputs?: Marketing_Read_The_DocsInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Read_The_DocsInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_read_the_docs(inputs)
	if (locale === "es") return es_marketing_read_the_docs(inputs)
	return fr_marketing_read_the_docs(inputs)
});